import React from 'react';
import './Contact.css';

const Contact: React.FC = () => {

  return (
    <div className="contact-page">
      <div className="contact-container">
        <div className="contact-header">
          <h1 className="contact-title">Contact Us</h1>
          <p className="contact-subtitle">
            Have questions about roadside help, DIY tutorials, or joining as a helper or instructor? We'd love to hear from you!
          </p>
        </div>

        <div className="contact-form-container">
          <div className="form-header">
            <h2>Send us a Message</h2>
            <p>Fill out the form below and we'll get back to you as soon as possible.</p>
          </div>
          
          <div className="google-form-container">
            <iframe
              src="https://docs.google.com/forms/d/e/1FAIpQLSdV5Z9QKmqbo8G0yDhQYo4jDwK_dyTk_N1z-bh_FPkdTACRgg/viewform?embedded=true"
              width="100%"
              height="600"
              title="GetStrandX Contact Form"
              className="contact-form-iframe"
            >Loading…</iframe>
          </div>
        </div>

        <div className="contact-cta">
          <h3>Ready to Join the Community?</h3>
          <p>Whether you need help, want to learn, or have skills to teach — be among the first on the platform.</p>
          <a href="/#prelaunch-survey" className="cta-button">
            Get Early Access
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
